import OrgAdminPage from "pages/org-performance/OrgAdminPage";
import CRM from "pages/org-performance/CRM";

export default function CRMPage() {
  return (
    <OrgAdminPage>
      {(organization) => <CRM organization={organization} />}
    </OrgAdminPage>
  );
}
